{
  "status": {
    "PLANNING": "Planning",
    "ACTIVE": "Active",
    "ON_HOLD": "On hold",
    "COMPLETED": "Completed",
    "CLOSED": "Closed",
    "CANCELLED": "Cancelled"
  },
  "priority": {
    "LOW": "Low",
    "NORMAL": "Normal",
    "HIGH": "High",
    "URGENT": "Urgent"
  },
  "kind": {
    "CUSTOMER": "For a customer",
    "INTERNAL": "Internal",
    "CUSTOMERBody": "Work for a customer, billed to them.",
    "INTERNALBody": "The company's own work (a fit-out, a roll-out): cost only, never billed."
  },
  "billingMethod": {
    "FIXED_PRICE": "Fixed price",
    "TIME_AND_MATERIALS": "Time and materials",
    "PROGRESS_CLAIMS": "Progress claims",
    "NON_BILLABLE": "Not billed"
  },
  "progressMethod": {
    "MANUAL": "by progress updates",
    "TASKS": "by tasks",
    "MILESTONES": "by milestones",
    "COST_TO_COST": "by cost",
    "BOQ": "by bill of quantities"
  },
  "progressMethodName": {
    "MANUAL": "Progress updates",
    "TASKS": "Tasks",
    "MILESTONES": "Milestones",
    "COST_TO_COST": "Cost",
    "BOQ": "Bill of quantities"
  },
  "progressMethodHint": {
    "MANUAL": "The manager records a dated percentage on each part of the plan; the project's progress adds them up by weight.",
    "TASKS": "The share of the project's tasks completed, weighted by their estimates.",
    "MILESTONES": "The share of milestones achieved, weighted by their weight in the plan.",
    "COST_TO_COST": "Cost to date against the approved budget, both without the categories left out of progress; capped at 100%.",
    "BOQ": "Certified quantities against the bill of quantities (arrives with contracting)."
  },
  "nodeKind": {
    "PHASE": "Phase",
    "WORK_PACKAGE": "Work package",
    "MILESTONE": "Milestone"
  },
  "memberRole": {
    "MANAGER": "Manager",
    "MEMBER": "Member",
    "MANAGERBody": "Manages this project: edits it, its plan and its team.",
    "MEMBERBody": "Sees the project, adds notes and files, and works on its tasks."
  },
  "progress": {
    "label": "Progress",
    "valueText": "{{percent}} complete"
  },
  "marks": {
    "overdue": "overdue",
    "dates": "{{start}} – {{end}}",
    "from": "From {{start}}",
    "pastEnd": "past its end date",
    "late": "late"
  },
  "errors": {
    "PROJECT_ILLEGAL_MOVE": "The project can't move to that status from where it is now. Reload it to see its current status.",
    "PROJECT_CLOSE_BLOCKED": "Something on the project is still pending (a budget waiting for approval, draft purchases tagged to it, billing items neither invoiced nor cancelled, or time waiting for approval). Finish it, then close the project.",
    "PROJECT_NOT_OPEN": "Closed and cancelled projects take no new work or documents. Reopen it first.",
    "PROJECT_FEATURE_OFF": "That function is turned off for this project or in Settings › Projects.",
    "PROJECT_FEATURE_DEPENDENCY": "A function you switched on needs another one that is off. Turn that one on too.",
    "PROJECTS_MODULE_OFF": "Projects are turned off for your company.",
    "PROJECT_CUSTOMER_REQUIRED": "A project for a customer needs its customer; an internal project has none.",
    "PROJECT_CUSTOMER_MISMATCH": "This document's customer isn't the project's customer.",
    "PROJECT_MANAGER_INACTIVE": "The manager must be an active user. Choose someone whose account is enabled.",
    "PROJECT_MANAGER_MEMBERSHIP": "The project's manager stays on the team as a manager. Change the manager first.",
    "PROJECT_TYPE_ARCHIVED": "That project type is archived. Restore it in Settings › Project types or choose another.",
    "PROJECT_TYPE_CODE_TAKEN": "Another project type already has this code. Choose a different code.",
    "PROJECT_PROGRESS_METHOD_UNAVAILABLE": "That progress method isn't available yet, or needs a function that is off.",
    "PROJECT_NODE_CYCLE": "A part of the plan can't go under one of its own parts.",
    "PROJECT_MILESTONE_LEAF": "A milestone can't have parts under it. Make it a phase or a work package first.",
    "PROJECT_NODE_LIMIT": "A plan holds at most 2,000 rows. Group the work into fewer rows.",
    "PROJECT_NODE_NOT_IN_PROJECT": "That row isn't in this project's plan any more. Reload the plan.",
    "PROJECT_NOT_A_MILESTONE": "Only milestones are marked achieved.",
    "PROJECT_PLAN_NOT_EMPTY": "A template applies only to an empty plan.",
    "PROJECT_TASK_NOT_LINKED": "That task isn't linked to this project. Link it first.",
    "PROJECT_TASK_ONE_PROJECT": "A task belongs to one project at most. Unlink it from the other project first.",
    "PROJECT_OPEN_MILESTONES": "Achieve or remove the open milestones first.",
    "PROJECT_SERIAL_GOODS": "Serial-tracked goods can't be delivered straight to a site. Receive them into stock, then issue them to the project.",
    "PROJECT_BUDGET_OPEN": "This project already has a budget being prepared or waiting for approval. Open that version instead.",
    "PROJECT_BUDGET_ILLEGAL_MOVE": "This budget version can't do that from its current status. Reload it to see where it is now.",
    "PROJECT_BUDGET_REASON_REQUIRED": "Say why the budget changes: from version 2 on, a reason is required.",
    "APPROVAL_REQUIRED": "Budget approval is on for this project: submit the budget for approval instead.",
    "APPROVAL_PENDING": "An approval workflow is deciding this budget. It is approved from My approvals.",
    "SELF_APPROVAL": "You prepared or submitted this budget, so someone else with budget approval must approve it.",
    "PROJECT_COST_CATEGORY_CODE_TAKEN": "Another cost category already has this code. Choose a different code.",
    "PROJECT_COST_ENTRY_UNBALANCED": "The lines of a transfer must add up to zero. Make what is taken off equal what is added.",
    "closeBlockers": {
      "lead": "Finish these before closing the project.",
      "PENDING_BUDGET": "A budget waits for approval: approve or withdraw it.",
      "OPEN_COMMITMENTS": "Draft purchases tagged to it: {{count}}. Post, cancel or untag them.",
      "OPEN_BILLING_ITEMS": "Billing items neither invoiced nor cancelled: {{count}}. Invoice or cancel them.",
      "SUBMITTED_TIME": "Time entries waiting for approval: {{count}}. Approve or return them in Time approvals."
    }
  },
  "blocked": {
    "NOT_PERMITTED": "You can't do this on this project.",
    "ILLEGAL_MOVE": "Not possible from the project's current status.",
    "NO_START_DATE": "Set a start date first.",
    "OPEN_MILESTONES": "Achieve or remove the open milestones first.",
    "FEATURE_OFF": "That function is turned off for this project.",
    "PENDING_WORK": "A budget waits for approval, draft purchases are still tagged to this project, billing items are neither invoiced nor cancelled, or time waits for approval. Finish them first."
  },
  "actions": {
    "new": "New project",
    "export": "Export",
    "edit": "Edit",
    "functions": "Functions",
    "history": "History",
    "activate": "Activate",
    "hold": "Put on hold",
    "resume": "Resume",
    "complete": "Complete project",
    "close": "Close project",
    "reopen": "Reopen project",
    "cancel": "Cancel project"
  },
  "lifecycle": {
    "reason": "Reason",
    "reasonRequired": "Give a reason.",
    "becomes": "becomes",
    "keep": "Keep the project",
    "actualStart": "Actual start",
    "actualFinish": "Actual finish",
    "dateHint": "Today unless the work started or finished on another day.",
    "activate": {
      "title": "Activate {{code}}?",
      "body": "Work starts: people log progress and tasks against it.",
      "confirm": "Activate project",
      "toast": "{{code}} activated"
    },
    "hold": {
      "title": "Put {{code}} on hold?",
      "body": "Work pauses until someone resumes it. The reason is kept in its history.",
      "confirm": "Put on hold",
      "toast": "{{code}} put on hold"
    },
    "resume": {
      "title": "Resume {{code}}?",
      "body": "The project becomes active again.",
      "confirm": "Resume project",
      "toast": "{{code}} resumed"
    },
    "complete": {
      "title": "Complete {{code}}?",
      "body": "The work is done; documents can still be recorded until it is closed.",
      "confirm": "Complete project",
      "toast": "{{code}} completed"
    },
    "close": {
      "title": "Close {{code}}?",
      "body": "Closed projects take no new documents or work. Only Reopen changes that.",
      "confirm": "Close project",
      "toast": "{{code}} closed"
    },
    "reopen": {
      "title": "Reopen {{code}}?",
      "body": "The project becomes active again. The reason is kept in its history.",
      "confirm": "Reopen project",
      "toast": "{{code}} reopened"
    },
    "cancel": {
      "title": "Cancel {{code}}?",
      "body": "A cancelled project can't be reopened. Its tasks go back to their teams.",
      "confirm": "Cancel project",
      "toast": "{{code}} cancelled"
    }
  },
  "people": {
    "inactive": "inactive",
    "error": "People couldn't be loaded. Try again.",
    "placeholder": "Choose a person",
    "search": "Search people…",
    "empty": "No one matches."
  },
  "site": {
    "placeholder": "Choose a site",
    "search": "Search sites…",
    "none": "No sites yet. Add them in Settings › Work locations."
  },
  "columns": {
    "code": "Code",
    "name": "Project",
    "manager": "Manager",
    "status": "Status",
    "progress": "Progress",
    "nextMilestone": "Next milestone",
    "start": "Start",
    "end": "End",
    "type": "Type",
    "unit": "Unit",
    "contractValue": "Contract value",
    "health": "Health"
  },
  "fields": {
    "type": "Project type",
    "kind": "Kind",
    "name": "Name",
    "nameAr": "Name in Arabic",
    "customer": "Customer",
    "manager": "Manager",
    "startDate": "Start",
    "endDate": "End",
    "contractValue": "Contract value",
    "orgUnit": "Unit",
    "site": "Site",
    "priority": "Priority",
    "contractReference": "Contract or PO reference",
    "description": "Description",
    "billingMethod": "Billing method",
    "progressMethod": "Progress measured"
  },
  "filters": {
    "status": "Status",
    "anyStatus": "Any status",
    "type": "Project type",
    "anyType": "Any type",
    "manager": "Manager",
    "anyManager": "Any manager",
    "managedByMe": "Managed by me",
    "customer": "Customer",
    "anyCustomer": "Any customer",
    "unit": "Unit",
    "anyUnit": "Any unit",
    "chosenPerson": "Chosen person",
    "chosenCustomer": "Chosen customer",
    "health": "Health",
    "anyHealth": "Any health",
    "signal": "Alert",
    "anySignal": "Any alert"
  },
  "portfolio": {
    "title": "Projects",
    "views": "Project views",
    "view": {
      "mine": "My projects",
      "active": "Active",
      "attention": "Needs attention",
      "all": "All",
      "closed": "Closed"
    },
    "searchPlaceholder": "Search code, name or customer…",
    "searchLabel": "Search projects",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "filters": "Filters",
    "filtersCount_one": "Filters, {{n}} on",
    "filtersCount_other": "Filters, {{n}} on",
    "layout": {
      "label": "Layout",
      "list": "List",
      "board": "Board",
      "timeline": "Timeline"
    },
    "figures": "Portfolio figures",
    "activeContractValue": "Active contracts",
    "activeContractSub_one": "{{n}} active project",
    "activeContractSub_other": "{{n}} active projects",
    "tableLabel": "Projects",
    "exported": "Projects exported",
    "empty": {
      "filteredTitle": "No projects match these filters.",
      "filteredBody": "Clear a filter or search for something else.",
      "view": {
        "mine": "You're not on any open project.",
        "active": "No projects in planning, active or on hold.",
        "attention": "Nothing needs attention: no project has a warning or a critical alert.",
        "all": "No projects yet.",
        "closed": "No completed, closed or cancelled projects yet."
      }
    },
    "first": {
      "title": "Start your first project",
      "body": "A project gathers its plan, team, tasks and files in one place. Pick how to begin; you can change everything afterwards.",
      "titleReader": "No projects yet.",
      "bodyReader": "Projects appear here once someone starts one.",
      "blank": "Blank",
      "blankBody": "Name it, choose the customer and the dates, and build the plan yourself.",
      "type": "From a project type",
      "typeBody": "Start from a standard type (construction, fit-out, service) with its plan dated from your start date.",
      "quotation": "From an approved quotation",
      "quotationBody": "Arrives with billing: the quotation's customer, value and lines fill the project."
    },
    "strip": {
      "billed": "Billed",
      "costToDate": "Cost to date",
      "forecastMargin": "Expected margin",
      "forecastMarginSub": "Measured projects",
      "unbilled": "Unbilled",
      "retentionHeld": "Retention held"
    },
    "health": {
      "asOf": "Health as of {{time}}",
      "notYet": "Health not checked yet",
      "refresh": "Refresh",
      "refreshing": "Refreshing…",
      "refreshLabel": "Refresh project health now",
      "queued": "Health refresh queued. The figures update within a few minutes."
    },
    "figuresToggle": "Figures",
    "stripScope": "These figures cover every active project you can see, whatever the tab or filters."
  },
  "board": {
    "label": "Projects by status",
    "column": "{{status}} projects",
    "dragHint": "Drag a card to another column to change its status; you confirm before anything changes.",
    "empty": "None",
    "moveTo": "Move {{code}} to…",
    "refused": "{{code}} can't go from {{from}} to {{to}}.",
    "ends": "ends {{date}}",
    "more": "Showing {{shown}} of {{total}}. Filter to see the rest."
  },
  "timeline": {
    "label": "Projects on a timeline",
    "groupBy": "Group by",
    "group": {
      "none": "No grouping",
      "manager": "Manager",
      "customer": "Customer"
    },
    "empty": "No projects run in this period.",
    "lateLegend": "Late",
    "legendJoin": ", "
  },
  "new": {
    "title": "New project",
    "description": "It starts in Planning; you activate it when work begins.",
    "discardTitle": "Discard this new project?",
    "discardBody": "What you entered will be lost.",
    "discard": "Discard",
    "keepEditing": "Keep editing",
    "start": "Start from",
    "modes": {
      "blank": "Blank",
      "blankBody": "An empty plan you build yourself.",
      "type": "A project type",
      "typeBody": "Its functions, billing and plan template.",
      "quotation": "A quotation",
      "quotationBody": "An approved quotation: its customer, value and lines.",
      "quotationOff": "Needs Sales, and permission to read quotations."
    },
    "namePlaceholder": "e.g. Al Khoud villa fit-out",
    "managerHint": "You, unless someone else runs it.",
    "contractHint": "The original value agreed, before any variations.",
    "planPreview": "Plan from the template",
    "applyTemplate": "Create these rows",
    "noTemplate": "This type has no plan template.",
    "emptyPlan": "The project starts with an empty plan.",
    "previewHint": "Dated in working days from the start, skipping weekends and holidays.",
    "moreDetails": "More details",
    "unitHint": "Your own unit unless you choose another.",
    "noUnit": "No unit",
    "siteHint": "Where the work happens.",
    "noSite": "No site",
    "save": "Create project",
    "created": "{{code}} created",
    "errors": {
      "type": "Choose a project type.",
      "name": "Enter the project's name.",
      "customer": "Choose the customer.",
      "start": "Enter the start date.",
      "end": "The end is before the start."
    }
  },
  "workspace": {
    "title": "Project",
    "backToPortfolio": "Back to projects",
    "managedBy": "Managed by {{name}}",
    "workingDaysLeft_one": "{{n}} working day left",
    "workingDaysLeft_other": "{{n}} working days left",
    "pastEnd": "Past its end date",
    "statusAlert": {
      "CANCELLED": "Cancelled on {{date}}",
      "ON_HOLD": "On hold since {{date}}"
    },
    "planOff": "The plan is turned off for this project (Functions in the More menu).",
    "moneyHidden": "You need permission to see project money."
  },
  "tabs": {
    "label": "Project sections",
    "overview": "Overview",
    "plan": "Plan",
    "tasks": "Tasks",
    "team": "Team",
    "files": "Files",
    "activity": "Activity",
    "budget": "Budget & cost"
  },
  "edit": {
    "title": "Edit {{code}}",
    "save": "Save project",
    "saved": "{{code}} saved",
    "managerHint": "The new manager joins the team as a manager.",
    "billingLocked": "Fixed once the project is active."
  },
  "functions": {
    "title": "Functions of this project",
    "body": "Switch off what this project doesn't use; its tab and actions disappear.",
    "save": "Save functions",
    "saved": "Functions saved",
    "companyOff": "Turned off for the whole company in Settings › Projects.",
    "approverOnly": "Only someone who may approve budgets can change budget approval."
  },
  "overview": {
    "attention": {
      "title": "Needs attention",
      "none": "Nothing needs attention.",
      "overdueMilestones_one": "overdue milestone",
      "overdueMilestones_other": "overdue milestones",
      "overdueReason_one": "Past its due date and not achieved.",
      "overdueReason_other": "Past their due date and not achieved.",
      "pastEnd": "Past its end date",
      "pastEndReason_one": "It was due to end {{date}}, {{days}} day ago. Move the end date or complete it.",
      "pastEndReason_other": "It was due to end {{date}}, {{days}} days ago. Move the end date or complete it.",
      "notActivated": "Still in planning",
      "notActivatedReason": "It was due to start {{date}}. Activate it or move the start.",
      "overdueTasks_one": "overdue task",
      "overdueTasks_other": "overdue tasks",
      "overdueTasksReason_one": "Open and past its due date.",
      "overdueTasksReason_other": "Open and past their due date.",
      "failed": "The project's signals couldn't be loaded, so this list may be missing alerts.",
      "retry": "Try again"
    },
    "progress": {
      "title": "Progress",
      "method": "Measured {{method}}",
      "how": "How is this calculated?"
    },
    "milestones": {
      "title": "Next milestones",
      "openPlan": "Open the plan",
      "none": "No open milestones.",
      "late_one": "{{n}} day late",
      "late_other": "{{n}} days late"
    },
    "notes": {
      "title": "Pinned notes",
      "all": "All notes",
      "none": "No pinned notes.",
      "by": "{{name}} · {{date}}"
    },
    "details": "Details",
    "noType": "No type",
    "planned": "Planned",
    "actual": "Actual",
    "created": "Created",
    "createdBy": "{{date}} by {{name}}",
    "team": "Team",
    "teamAll_one": "{{n}} person",
    "teamAll_other": "All {{n}} people",
    "trail": "Paperwork",
    "quotation": "Quotation",
    "projectSlip": "Project",
    "closedNote": {
      "COMPLETED": "The work is done. Close the project once nothing is left to record.",
      "CLOSED": "Closed: no new documents or work. Reopen it to record more.",
      "CANCELLED": "Cancelled: kept for its history."
    }
  },
  "plan": {
    "unavailable": "The plan couldn't be loaded.",
    "add": {
      "PHASE": "Add phase",
      "WORK_PACKAGE": "Add work package",
      "MILESTONE": "Add milestone"
    },
    "addSave": "Add to plan",
    "save": "Save",
    "toast": {
      "saved": "{{name}} saved",
      "added": "{{name}} added to the plan",
      "achieved": "{{name}} achieved",
      "unachieved": "{{name}} taken back",
      "progress": "{{name}} at {{percent}}%",
      "removed": "{{name}} removed from the plan",
      "rescheduled": "{{name}} rescheduled",
      "template": "Plan created from the template",
      "moved": {
        "up": "{{name}} moved up",
        "down": "{{name}} moved down",
        "indent": "{{name}} moved under the row above",
        "outdent": "{{name}} moved up a level"
      }
    },
    "menu": {
      "label": "Actions for {{name}}",
      "addWorkPackage": "Add work package under it",
      "addMilestone": "Add milestone under it",
      "up": "Move up",
      "down": "Move down",
      "indent": "Move under the row above",
      "outdent": "Move up a level",
      "open": "Open"
    },
    "achieve": "Mark achieved",
    "unachieve": "Take back",
    "updateProgress": "Update progress",
    "columns": {
      "name": "Plan",
      "start": "Start",
      "finish": "Finish",
      "days": "Working days",
      "weight": "Weight",
      "progress": "Progress",
      "tasks": "Open tasks",
      "actions": "Actions"
    },
    "achievedOn": "Achieved {{date}}",
    "overdue": "Overdue",
    "late": "late",
    "legend": {
      "planned": "Planned",
      "late": "Late"
    },
    "open": "Open",
    "viewLabel": "Plan view",
    "view": {
      "table": "Table",
      "timeline": "Timeline"
    },
    "applyTemplate": "Apply template",
    "applyBody": "These rows are created with dates counted in working days from the start, {{date}}.",
    "applyConfirm": "Create the plan",
    "empty": {
      "title": "No plan yet",
      "body": "Apply the type's template or add the first phase.",
      "reader": "The project's manager hasn't planned it yet."
    },
    "timelineHint": "Drag a bar or a diamond to propose new dates (or Alt with an arrow key); you confirm before anything moves.",
    "timelineLabel": "Plan of {{code}} on a timeline",
    "keysHint": "On a row: Alt+↑/↓ reorders, Alt+→ moves it under the row above, Alt+← moves it up a level, Enter opens it.",
    "tableLabel": "Plan of {{code}}",
    "moveTitle": "Move {{name}} by {{days}} working days?",
    "moveBody": "New dates: {{start}} – {{end}}. Milestones after it keep their dates.",
    "moveBodyMilestone": "New due date: {{date}}.",
    "moveConfirm": "Move it",
    "inline": {
      "label": "Add a row to the plan",
      "name": "Name of the new row",
      "placeholder": "Name, then Enter",
      "add": "Add"
    },
    "fields": {
      "kind": "Kind",
      "parent": "Under",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "start": "Planned start",
      "finish": "Planned finish",
      "due": "Due",
      "weight": "Weight",
      "outline": "Outline",
      "openTasks": "Open tasks"
    },
    "topLevel": "Top level",
    "errors": {
      "name": "Enter a name.",
      "finish": "The finish is before the start.",
      "weight": "Enter a whole number from 0 to 1,000.",
      "percent": "Enter a percentage from 0 to 100."
    },
    "hints": {
      "kindWithChildren": "A row with rows under it can't become a milestone.",
      "weight": "How much it counts in the project's progress."
    },
    "workingDays_one": "{{count}} working day",
    "workingDays_other": "{{count}} working days",
    "acceptance": "Acceptance",
    "unachieveReason": "Why take it back?",
    "achievedOnLabel": "Achieved on",
    "achieveNote": "Note",
    "achieveNoteHint": "The client's reference or who accepted it.",
    "progressTitle": "Progress",
    "percent": "Percent complete",
    "asOf": "As of",
    "progressNote": "Note",
    "saveProgress": "Save progress",
    "history": "Progress history",
    "historyLine": "as of {{date}} · {{name}}",
    "noHistory": "No progress recorded yet.",
    "remove": "Remove from plan",
    "removeTitle": "Remove {{name}}?",
    "removeBody": "It leaves the plan; its history stays in Activity.",
    "removeBodyChildren": "The rows under it are removed too; their history stays in Activity."
  },
  "tasks": {
    "new": "New task",
    "layout": "Tasks layout",
    "list": "List",
    "board": "Board",
    "tableLabel": "Tasks of {{code}}",
    "place": "Place in plan…",
    "rowActions": "Actions for {{number}}",
    "empty": "No tasks on this project yet.",
    "emptyBody": "Add the first task; it is linked to this project.",
    "placed": "{{number}} placed in the plan",
    "placeTitle": "Place {{number}} in the plan",
    "placeConfirm": "Place task",
    "node": "Part of the plan",
    "nodeHint": "Its open tasks count on that row and, with progress by tasks, its completion.",
    "nowhere": "Nowhere in particular",
    "groupByNode": "Group by plan node",
    "groupLabel": "Tasks in {{node}} of {{code}}",
    "groupCount_one": "{{count}} task",
    "groupCount_other": "{{count}} tasks",
    "notInPlan": "Not in the plan",
    "groupCapped": "Grouping covers the first {{shown}} of {{total}} tasks. Use the list to see the rest.",
    "currentNode": "Now in {{node}}.",
    "currentNowhere": "Not in the plan yet."
  },
  "team": {
    "add": "Add member",
    "tableLabel": "Team of {{code}}",
    "columns": {
      "person": "Person",
      "access": "Access",
      "role": "Role on the project",
      "added": "Added",
      "actions": "Actions"
    },
    "projectManager": "Project manager",
    "addedBy": "{{date}} by {{name}}",
    "edit": "Change {{name}}",
    "remove": "Remove {{name}}",
    "removeTitle": "Remove {{name}} from the team?",
    "removeBody": "They stop seeing the project's tasks shared with its team. Their open tasks stay assigned to them; reassign them from Tasks.",
    "removeConfirm": "Remove from team",
    "removed": "{{name}} removed from the team",
    "errors": {
      "person": "Choose a person."
    },
    "saved": "{{name}} updated",
    "added": "{{name}} added to the team",
    "editTitle": "{{name}} on this project",
    "addTitle": "Add a team member",
    "save": "Save",
    "addConfirm": "Add to team",
    "person": "Person",
    "access": "Access",
    "managerFixed": "The project's manager is always a manager here.",
    "roleTitle": "Role on the project",
    "roleTitleHint": "e.g. Site engineer, Quantity surveyor."
  },
  "notes": {
    "title": "Notes",
    "new": "New note",
    "placeholder": "Write a note for the team…",
    "add": "Add note",
    "added": "Note added",
    "none": "No notes yet.",
    "pinned": "Pinned",
    "pin": "Pin note",
    "unpin": "Unpin note",
    "remove": "Remove note",
    "removeTitle": "Remove this note?",
    "removeBody": "It disappears from the project; the removal is kept in its history.",
    "errors": {
      "empty": "Write something first."
    },
    "toast": {
      "pin": "Note pinned",
      "unpin": "Note unpinned",
      "remove": "Note removed"
    },
    "pinNamed": "Pin the note by {{name}}, {{date}}",
    "unpinNamed": "Unpin the note by {{name}}, {{date}}",
    "removeNamed": "Remove the note by {{name}}, {{date}}"
  },
  "activity": {
    "title": "Activity",
    "none": "Nothing has happened yet.",
    "newer": "Newer",
    "older": "Older",
    "page": "Page {{page}} of {{pages}}",
    "system": "Sahab",
    "other": "made a change to the {{entity}}",
    "entity": {
      "PROJECT": "project",
      "MEMBER": "team member",
      "NODE": "part of the plan",
      "NOTE": "note",
      "FILE": "file"
    },
    "action": {
      "CREATE": "created the {{entity}}",
      "UPDATE": "changed the {{entity}}",
      "ACTIVATE": "activated the project",
      "HOLD": "put the project on hold",
      "RESUME": "resumed the project",
      "COMPLETE": "completed the project",
      "CLOSE": "closed the project",
      "REOPEN": "reopened the project",
      "CANCEL": "cancelled the project",
      "FEATURES": "changed the project's functions",
      "ADD": "added a {{entity}}",
      "REMOVE": "removed a {{entity}}",
      "MOVE": "moved a {{entity}}",
      "ACHIEVE": "marked a milestone achieved",
      "UNACHIEVE": "took a milestone back",
      "PROGRESS": "updated progress",
      "APPLY_TEMPLATE": "created the plan from a template",
      "PIN": "pinned a note",
      "UNPIN": "unpinned a note",
      "ATTACH": "attached a file",
      "DETACH": "removed a file",
      "UPDATE_FEATURES": "changed the project's functions",
      "APPLY_PLAN": "added a plan from the assistant",
      "ADD_MEMBER": "added a team member",
      "UPDATE_MEMBER": "changed a team member's access",
      "REMOVE_MEMBER": "removed a team member",
      "ADD_NOTE": "added a note",
      "PIN_NOTE": "pinned a note",
      "UNPIN_NOTE": "unpinned a note",
      "REMOVE_NOTE": "removed a note",
      "ADD_NODE": "added to the plan",
      "UPDATE_NODE": "changed the plan",
      "MOVE_NODE": "moved a part of the plan",
      "REMOVE_NODE": "removed a part of the plan",
      "ACHIEVE_MILESTONE": "marked a milestone achieved",
      "UNACHIEVE_MILESTONE": "took a milestone back",
      "PLACE_TASK": "placed a task in the plan",
      "BUDGET_CREATE": "started a budget version",
      "BUDGET_UPDATE": "edited the draft budget",
      "BUDGET_DELETE": "deleted a draft budget",
      "BUDGET_SUBMIT": "sent the budget for approval",
      "BUDGET_APPROVE": "approved the budget",
      "BUDGET_RETURN": "returned the budget",
      "BILL": "issued an invoice",
      "BILL_VOID": "voided an invoice",
      "BILLING_OVERRIDE": "changed a line to bill",
      "EXPORT": "exported project data",
      "SIGNAL_ACKNOWLEDGE": "acknowledged an alert",
      "SIGNAL_UNACKNOWLEDGE": "reopened an alert",
      "CONTRACT_CREATE": "started the contract",
      "CONTRACT_UPDATE": "changed the contract terms",
      "CONTRACT_ACTIVATE": "activated the contract",
      "CONTRACT_AMEND": "amended the contract",
      "CONTRACT_PRACTICAL_COMPLETION": "recorded practical completion",
      "CONTRACT_CLOSE": "closed the final account",
      "CLAIM_CERTIFY": "certified a claim",
      "CLAIM_VOID": "voided a claim certificate",
      "RETENTION_RELEASE": "released retention",
      "RETENTION_FORFEIT": "forfeited retention"
    },
    "family": {
      "budget": "changed the budget",
      "billingPlan": "changed the billing plan",
      "billing": "changed the billing",
      "claim": "changed a claim",
      "variation": "changed a variation",
      "guarantee": "changed a guarantee",
      "boq": "changed the bill of quantities",
      "retention": "changed the retention",
      "contract": "changed the contract",
      "signal": "changed an alert"
    }
  },
  "customerTab": {
    "title": "Projects",
    "count_one": "{{n}} project",
    "count_other": "{{n}} projects",
    "showAll": "Show in Projects",
    "empty": "No projects for this customer yet.",
    "emptyBody": "Start one; it opens with this customer chosen."
  },
  "settings": {
    "defaults": "New projects",
    "reload": "Load their changes",
    "conflict": "Someone else saved these settings meanwhile. Load their changes, then make yours again.",
    "thresholds": {
      "title": "Budget levels",
      "body": "Budget use is actual plus committed cost against the approved budget. From these levels a project turns amber, then red, and its manager is told once per level.",
      "warn": "Warning at",
      "warnHint": "Amber, and a notice to the manager.",
      "critical": "Over budget at",
      "criticalHint": "Red: usually 100%, the budget itself.",
      "order": "The critical level must be above the warning level.",
      "range": "Enter a whole percentage from 1 to 500."
    },
    "categoryDefaults": {
      "title": "Cost category when none is chosen",
      "body": "Used when the clerk leaves the category empty and neither the product category, the account nor the expense category is mapped (Settings › Cost categories).",
      "seeded": "The standard one ({{code}})",
      "source": {
        "goods": "Goods bought for a project",
        "services": "Services bought for a project",
        "expense": "Expenses",
        "materialIssue": "Materials issued from stock",
        "time": "Time",
        "salesCogs": "Cost of goods sold (with billing)"
      },
      "hint": {
        "goods": "Purchase lines of products delivered to the site.",
        "services": "Purchase lines of services and free text.",
        "expense": "Expenses tagged to a project.",
        "materialIssue": "Stock issued to a project.",
        "time": "Approved hours logged on projects.",
        "salesCogs": "Arrives with project billing."
      }
    }
  },
  "types": {
    "placeholder": "Choose a project type",
    "search": "Search types…",
    "none": "No project types. Add them in Settings › Project types.",
    "addPresets": "Add standard types",
    "presetsAdded_one": "{{count}} standard type added",
    "presetsAdded_other": "{{count}} standard types added",
    "presetsNone": "You already have every standard type",
    "new": "New type",
    "newTitle": "New project type",
    "editTitle": "Edit type {{code}}",
    "views": "Project type views",
    "active": "Active",
    "archived": "Archived",
    "archivedStamp": "Archived",
    "listLabel": "Project types",
    "templateCount_one": "{{count}} plan row",
    "templateCount_other": "{{count}} plan rows",
    "projectCount_one": "{{count}} project",
    "projectCount_other": "{{count}} projects",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "It can't start new projects; projects already created from it keep running.",
    "archiveConfirm": "Archive type",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "It can start new projects again.",
    "restoreConfirm": "Restore type",
    "toastArchived": "{{name}} archived",
    "toastRestored": "{{name}} restored",
    "empty": "No project types yet.",
    "emptyBody": "Add the standard types and adjust them, or create your own.",
    "emptyArchived": "No archived types.",
    "save": "Save type",
    "saved": "{{name}} saved",
    "internalBilling": "Internal projects are never billed.",
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "functions": "Functions"
    },
    "errors": {
      "code": "Use up to 20 letters, digits, dashes or underscores.",
      "name": "Enter the type's name.",
      "billing": "A project for a customer is billed: choose how.",
      "nodeName": "Enter the row's name.",
      "nodeKey": "Use up to 20 letters, digits, dots, dashes or underscores.",
      "keyTwice": "This key is used twice.",
      "milestoneParent": "A milestone can't have rows under it.",
      "parentOrder": "Its parent must come earlier in the list."
    },
    "template": {
      "title": "Plan template",
      "hint": "Offsets and durations in working days from the project's start.",
      "empty": "No rows: projects of this type start with an empty plan.",
      "row": "Template row {{n}}",
      "key": "Key",
      "under": "Under",
      "topLevel": "Top level",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "offset": "Starts after",
      "duration": "Lasts",
      "up": "Move {{key}} up",
      "down": "Move {{key}} down",
      "remove": "Remove {{key}}",
      "moved": "Moved {{key}} to position {{n}}",
      "removed": "Removed {{key}}"
    }
  },
  "costs": {
    "projectLevel": "The whole project",
    "archived": "archived",
    "budgetsOff": "Budgets are turned off for this project: costs only.",
    "docStatus": {
      "POSTED": "Posted",
      "VOID": "Void"
    },
    "band": {
      "NONE": "nothing budgeted",
      "NORMAL": "within budget",
      "WARN": "near the limit",
      "CRITICAL": "over the limit"
    },
    "class": {
      "LABOUR": "Labour",
      "MATERIAL": "Materials",
      "SUBCONTRACT": "Subcontract",
      "EQUIPMENT": "Equipment",
      "EXPENSE": "Expenses",
      "OVERHEAD": "Overhead",
      "OTHER": "Other"
    },
    "source": {
      "purchase": "Purchase",
      "supplier_return": "Supplier return",
      "expense": "Expense",
      "project_material_issue": "Material issue",
      "project_cost_entry": "Cost entry",
      "project_material_return": "Material return",
      "sales_invoice": "Invoice",
      "credit_note": "Credit note",
      "receipt": "Receipt",
      "project_opening": "Opening figures",
      "project_claim": "Progress claim",
      "project_retention_forfeit": "Retention forfeited",
      "customer_refund": "Refund",
      "project_time_entry": "Time"
    },
    "actions": {
      "label": "Record cost",
      "issue": "Issue materials",
      "return": "Return materials",
      "entry": "New cost entry",
      "purchase": "New purchase",
      "expense": "New expense"
    },
    "figures": {
      "label": "Budget and cost figures",
      "budget": "Budget",
      "committed": "Committed",
      "committedSub": "draft purchases",
      "actual": "Actual",
      "actualSub": "posted documents",
      "remaining": "Remaining",
      "remainingSub": "still free",
      "overSub": "over budget",
      "use": "Use",
      "useSub": "Warn {{warn}}% · over {{critical}}%",
      "margin": "Budgeted margin"
    },
    "rule": {
      "label": "{{use}} of the budget used; warning at {{warn}}%, over budget at {{critical}}%",
      "rowLabel": "{{use}} of the budget used",
      "budget": "Budget",
      "actual": "Actual",
      "committed": "Committed"
    },
    "empty": {
      "budgetTitle": "Add a budget to see cost against plan",
      "budgetBody": "Costs below are still counted; with an approved budget each category shows what is left and how much is used.",
      "costs": "Costs appear here when purchases, expenses or stock issues are tagged to this project."
    },
    "table": {
      "titleBudget": "Budget against cost",
      "titleCost": "Cost",
      "views": "Group the figures",
      "by": {
        "category": "By category",
        "node": "By plan node",
        "both": "Node × category"
      },
      "caption": "Budget, committed and actual cost of the project",
      "category": "Category",
      "node": "Plan node",
      "nodeCategory": "Plan node and category",
      "notInBudget": "Not in budget",
      "total": "Total"
    },
    "lines": {
      "title": "Cost lines",
      "date": "Date",
      "source": "Document",
      "sourceType": "Document type",
      "party": "Supplier",
      "description": "Description",
      "node": "Plan node",
      "category": "Category",
      "amount": "Amount",
      "draft": "Draft",
      "notOpenable": "You can't open this document",
      "open": "Open document",
      "move": "Move to another project…",
      "actionsFor": "Actions for {{number}}",
      "allNodes": "All plan nodes",
      "allCategories": "All categories",
      "allSources": "All documents",
      "clear": "Clear filters",
      "noMatch": "No cost lines match these filters.",
      "kind": "Show",
      "kindCost": "Posted costs",
      "kindCommitment": "Committed (draft purchases)",
      "chargedTo": "Charged to",
      "noCommitments": "No draft purchases are tagged to this project."
    },
    "card": {
      "title": "Budget & cost",
      "open": "Open Budget & cost",
      "used": "Budget used",
      "error": "The figures couldn't be loaded. Open Budget & cost to try again."
    },
    "pickers": {
      "category": "Choose a category",
      "categorySearch": "Search categories…",
      "categoryEmpty": "No category matches.",
      "node": "Choose a plan node",
      "project": "Choose a project",
      "projectSearch": "Search by code or name…",
      "projectEmpty": "No open project matches.",
      "projectError": "Projects couldn't be loaded.",
      "accountSearch": "Search accounts…",
      "accountEmpty": "No account matches."
    },
    "void": {
      "reason": "Reason",
      "reasonRequired": "Give a reason."
    },
    "errors": {
      "IN_USE": "A posted return refers to this issue. Void the return first.",
      "STOCK_ALREADY_USED": "The stock this brought back has been used since, so it can no longer be voided.",
      "INSUFFICIENT_STOCK": "Not that much is on hand in this warehouse.",
      "VERSION_CONFLICT": "Someone changed this meanwhile. Close it, open it again and redo your change."
    }
  },
  "budget": {
    "versionName": "Budget v{{n}}",
    "noBaseline": "No approved budget yet",
    "openVersion": {
      "DRAFT": "Continue draft v{{n}}",
      "PENDING": "v{{n}} waits for approval"
    },
    "status": {
      "DRAFT": "Draft",
      "PENDING": "Pending",
      "APPROVED": "Approved",
      "SUPERSEDED": "Superseded"
    },
    "editorTitle": "Budget v{{n}} · {{code}}",
    "editorLoading": "Budget",
    "editorDescription": "Lines by plan node and cost category; quantity × rate when you know them.",
    "preparedBy": "Prepared by {{name}}, {{date}}",
    "statusLine": {
      "direct": "You set the baseline directly: approving makes this version the budget.",
      "second": "Needs a second person with budget approval: submit it, then someone else approves it.",
      "secondPending": "Waiting for a second person with budget approval.",
      "workflow": "Goes to approval ({{workflow}}) when you submit it.",
      "workflowName": "the approval workflow",
      "workflowAt": "In approval: step {{index}} of {{total}}, {{step}}.",
      "approved": "The baseline since {{date}}, approved by {{name}}.",
      "superseded": "Replaced by a later approved version. Kept for history."
    },
    "actions": {
      "add": "Add a budget",
      "revise": "Revise budget",
      "save": "Save draft",
      "submit": "Submit",
      "approve": "Approve",
      "withdraw": "Withdraw",
      "delete": "Delete draft"
    },
    "blocked": {
      "NOT_PERMITTED": "You can't do this on this budget.",
      "ILLEGAL_MOVE": "Not possible from its current status.",
      "SELF_APPROVAL": "You prepared or submitted it: someone else with budget approval approves it.",
      "APPROVAL_REQUIRED": "Budget approval is on: submit it instead.",
      "WORKFLOW": "An approval workflow decides it: approve it from My approvals.",
      "REASON_REQUIRED": "Say why the budget changes first.",
      "PROJECT_NOT_OPEN": "The project is closed or cancelled.",
      "FEATURE_OFF": "Budgets are turned off for this project."
    },
    "fields": {
      "reason": "Reason for this version",
      "reasonHint": "Required from version 2: what changed and why.",
      "reasonOptional": "Optional for the first version.",
      "revenue": "Revenue planned",
      "revenueHint": "Leave empty for an internal project."
    },
    "summary": {
      "total": "Total cost",
      "revenue": "Revenue",
      "margin": "Margin",
      "change": "Change from the baseline"
    },
    "lines": {
      "label": "Budget lines",
      "add": "Add line",
      "remove": "Remove line {{n}}",
      "hint": "Enter on the last line adds another.",
      "none": "This version has no lines.",
      "node": "Plan node",
      "nodeOf": "Plan node, line {{n}}",
      "category": "Category",
      "categoryOf": "Category, line {{n}}",
      "quantity": "Quantity",
      "quantityOf": "Quantity, line {{n}}",
      "unit": "Unit",
      "unitOf": "Unit, line {{n}}",
      "rate": "Rate",
      "rateOf": "Rate, line {{n}}",
      "amount": "Amount",
      "amountOf": "Amount, line {{n}}",
      "computed": "Quantity × rate",
      "note": "Note",
      "noteOf": "Note, line {{n}}",
      "compare": "Baseline / actual",
      "new": "New",
      "changed": "Changed",
      "actualShort": "Actual"
    },
    "history": {
      "title": "Versions",
      "error": "The versions couldn't be loaded.",
      "prepared": "Prepared by {{name}}, {{date}}",
      "decided": "Approved by {{name}}, {{date}}",
      "picker": "Version"
    },
    "delete": {
      "title": "Delete draft v{{n}}?",
      "body": "The draft and its lines are removed. The approved budget stays as it is.",
      "confirm": "Delete draft"
    },
    "errors": {
      "fix": "Some lines need attention. Check the marked fields."
    },
    "toast": {
      "saved": "Draft v{{n}} saved",
      "submit": "Budget v{{n}} submitted for approval",
      "approve": "Budget v{{n}} approved: it is now the baseline",
      "withdraw": "Budget v{{n}} withdrawn: back to draft",
      "deleted": "Draft v{{n}} deleted"
    }
  },
  "materials": {
    "title": "Material issues",
    "subtitle": "Stock issued to projects and returned from them.",
    "kind": {
      "ISSUE": "Issue",
      "RETURN": "Return"
    },
    "backToSource": "Back to where it was charged",
    "backToList": "Back to material issues",
    "openProject": "Open project budget",
    "trail": "Issues and returns",
    "returnsLabel_one": "{{count}} return",
    "returnsLabel_other": "{{count}} returns",
    "voidTitle": "This document is void",
    "voidLine": "Reason: {{reason}}. Voided by {{name}}, {{date}}.",
    "createdLine": "{{name}}, {{date}}",
    "fields": {
      "number": "Number",
      "date": "Date",
      "kind": "Kind",
      "project": "Project",
      "warehouse": "Warehouse",
      "warehousePlaceholder": "Choose a warehouse",
      "node": "Plan node",
      "nodeHint": "Where on the plan the material is used.",
      "category": "Cost category",
      "categoryHint": "Empty: the company’s default for issued materials.",
      "categoryDefault": "The default for issued materials",
      "chargedTo": "Charged to",
      "reference": "Reference",
      "notes": "Notes",
      "value": "Value",
      "totalValue": "Total value",
      "status": "Status",
      "createdBy": "Recorded",
      "journal": "Journal entry"
    },
    "drawer": {
      "title": "Issue or return materials",
      "titleFor": "Materials for {{code}}",
      "description": "Posted on save: stock moves and the project is charged at once.",
      "kind": "Issue or return",
      "explain": {
        "ISSUE": "Stock leaves the warehouse and is charged to the project.",
        "RETURN": "Stock comes back and the project's cost goes down."
      },
      "posting": "Posted on {{date}} to {{project}}.",
      "submit": {
        "ISSUE": "Issue materials",
        "RETURN": "Return materials"
      }
    },
    "lines": {
      "label": "Materials",
      "add": "Add product",
      "remove": "Remove line {{n}}",
      "product": "Product",
      "productOf": "Product, line {{n}}",
      "productPlaceholder": "Search by name, SKU or barcode",
      "available": "Available",
      "quantity": "Quantity",
      "quantityOf": "Quantity, line {{n}}",
      "serials": "Serials",
      "serialList": "S/N {{serials}}",
      "returnOf": "Returned from",
      "returned": "Returned",
      "unitCost": "Unit cost",
      "shortage": "Only {{quantity}} {{unit}} on hand in this warehouse."
    },
    "return": {
      "title": "Still out on the project",
      "search": "Search product or document",
      "clearSearch": "Clear search",
      "none": "Nothing is out on this project: no materials were issued or delivered to its site.",
      "chooseProject": "Choose the project first to see what can come back.",
      "pick": "Return {{line}}",
      "source": {
        "ISSUE": "Issued",
        "PURCHASE": "Delivered to site"
      },
      "out": "Out",
      "back": "Back",
      "remaining": "Remaining",
      "unitCost": "Unit cost",
      "quantity": "Quantity back",
      "upTo": "Up to {{quantity}}",
      "serials": "Serial numbers coming back",
      "value": "Value back"
    },
    "list": {
      "search": "Search number or reference",
      "clearSearch": "Clear search",
      "allProjects": "All projects",
      "allKinds": "Issues and returns",
      "allStatuses": "Any status",
      "allWarehouses": "All warehouses",
      "actionsFor": "Actions for {{number}}",
      "empty": "No materials were issued to projects yet.",
      "noMatch": "No issue or return matches these filters."
    },
    "actions": {
      "open": "Open"
    },
    "void": {
      "action": "Void",
      "title": "Void {{number}}?",
      "body": {
        "ISSUE": "The stock goes back into the warehouse and the cost comes off the project, on the issue’s date.",
        "RETURN": "The stock leaves the warehouse again and the cost goes back onto the project, on the return’s date."
      },
      "confirm": "Void document"
    },
    "errors": {
      "fix": "Some lines need attention. Check the marked fields.",
      "project": "Choose the project.",
      "overReturn": "More than is still out comes back on {{number}}. Lower the quantity."
    },
    "toast": {
      "ISSUE": "{{number}} issued",
      "RETURN": "{{number}} returned",
      "voided": "{{number}} voided"
    },
    "returnFrom": "Return from this issue",
    "consequence": {
      "issue": "About {{amount}} to {{category}}.",
      "issueUse": "About {{amount}} to {{category}} (budget use {{use}}% after this).",
      "return": "About {{amount}} comes off the project's cost."
    },
    "viewJournal": "View journal entry",
    "journalPosted": "Posted"
  },
  "entries": {
    "title": "Cost entries",
    "subtitle": "Allocations, transfers between projects, opening costs and labour postings.",
    "backToList": "Back to cost entries",
    "kind": {
      "ALLOCATION": "Allocation",
      "TRANSFER": "Transfer",
      "OPENING": "Opening cost",
      "LABOUR_POSTING": "Labour posting"
    },
    "explain": {
      "ALLOCATION": "Charge cost that is on no document, such as your own equipment or a share of overheads, and credit an account.",
      "TRANSFER": "Move cost between projects, plan nodes or categories: take it off one line (negative) and add it to another.",
      "OPENING": "Cost incurred before the system was used. Nothing is posted to the books.",
      "LABOUR_POSTING": "Approved time cost to the books. Made with Post labour cost…, never typed."
    },
    "posting": {
      "ALLOCATION": "Posts each line to its category’s cost account and credits the account chosen.",
      "TRANSFER": "Posts between the cost accounts of the lines; nothing is posted when they share an account.",
      "OPENING": "No journal entry: the cost only counts on the projects.",
      "LABOUR_POSTING": "Debits each line's labour account and credits the account chosen."
    },
    "hidden_one": "{{count}} line on a project you can’t see",
    "hidden_other": "{{count}} lines on projects you can’t see",
    "hiddenBody": "They are part of this entry; their projects are outside what you can open.",
    "costHidden": "Amounts hidden: a labour posting shows people's hourly costs, which need permission to see hourly costs.",
    "voidTitle": "This entry is void",
    "fields": {
      "number": "Number",
      "date": "Date",
      "kind": "Kind",
      "description": "Description",
      "reference": "Reference",
      "projects": "Projects",
      "amount": "Amount",
      "status": "Status",
      "creditAccount": "Account credited",
      "creditAccountHint": "Where the cost comes from, e.g. equipment recovery or absorbed overheads.",
      "creditAccountPlaceholder": "Choose an account",
      "posting": "In the books"
    },
    "drawer": {
      "title": "New cost entry",
      "description": "Posted on save. To change it later, void it and record it again.",
      "submit": "Post cost entry"
    },
    "lines": {
      "label": "Lines",
      "add": "Add line",
      "remove": "Remove line {{n}}",
      "project": "Project",
      "projectOf": "Project, line {{n}}",
      "node": "Plan node",
      "nodeOf": "Plan node, line {{n}}",
      "category": "Category",
      "categoryOf": "Category, line {{n}}",
      "amount": "Amount",
      "signedAmount": "Amount (− takes off)",
      "amountOf": "Amount, line {{n}}",
      "note": "Note",
      "noteOf": "Note, line {{n}}",
      "total": "Total",
      "net": "Net",
      "moved": "Moved"
    },
    "balance": {
      "ok": "The lines add up to zero. Moving",
      "off": "The lines of a transfer must add up to zero. Off by"
    },
    "list": {
      "search": "Search number, description or reference",
      "clearSearch": "Clear search",
      "allKinds": "All kinds",
      "actionsFor": "Actions for {{number}}",
      "empty": "No cost entries yet.",
      "noMatch": "No cost entry matches these filters."
    },
    "actions": {
      "open": "Open"
    },
    "void": {
      "action": "Void",
      "title": "Void {{number}}?",
      "body": "The postings are reversed on the entry’s date and the cost comes off every project it named.",
      "confirm": "Void entry"
    },
    "errors": {
      "fix": "Some lines need attention. Check the marked fields.",
      "lines": "{{message}}"
    },
    "toast": {
      "created": "{{number}} posted",
      "voided": "{{number}} voided"
    },
    "move": {
      "title": "Move cost to another project",
      "description": "Moved from {{code}}: {{description}}"
    },
    "direction": "From {{from}} to {{to}}"
  },
  "categories": {
    "new": "New category",
    "newTitle": "New cost category",
    "editTitle": "Edit category {{code}}",
    "editorDescription": "How project costs are grouped, budgeted and posted.",
    "views": "Categories",
    "active": "Active",
    "archived": "Archived",
    "archivedStamp": "Archived",
    "listLabel": "Cost categories",
    "emptyActive": "No cost categories yet.",
    "emptyActiveBody": "The six standard ones are added the first time a project records a cost; add your own any time.",
    "emptyArchived": "No archived categories.",
    "defaultAccount": "Default project cost account",
    "billable": "Billable by default",
    "progressExcluded": "Left out of cost progress",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "It stays on recorded costs and budgets, but new lines can no longer use it.",
    "archiveConfirm": "Archive",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "It can be chosen on new costs and budget lines again.",
    "restoreConfirm": "Restore",
    "save": "Save category",
    "fields": {
      "code": "Code",
      "codeHint": "Letters, digits, dash and underscore; shown on lists and reports.",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "class": "Class",
      "classHint": "What kind of cost it holds; projects show cost by class.",
      "account": "Cost account",
      "accountHint": "An expense account for goods delivered to sites, issued materials and cost entries in this category.",
      "billable": "Billable by default",
      "billableHint": "Costs in it are billed on time-and-materials projects unless marked otherwise.",
      "progressExcluded": "Leave out of cost progress",
      "progressExcludedHint": "For costs that run ahead of the work, such as materials bought early."
    },
    "toast": {
      "saved": "Category {{code}} saved",
      "archived": "Category {{code}} archived",
      "restored": "Category {{code}} restored"
    },
    "map": {
      "title": "Which category a cost gets",
      "body": "When a clerk leaves the category empty, it comes from the product’s category, then the line’s account, then the expense category; otherwise from the defaults in Settings › Projects.",
      "kind": {
        "PRODUCT_CATEGORY": "Product categories",
        "ACCOUNT": "Accounts",
        "EXPENSE_CATEGORY": "Expense categories"
      },
      "hint": {
        "PRODUCT_CATEGORY": "A product in a sub-category uses the nearest mapped category above it.",
        "ACCOUNT": "For service and free-text purchase lines.",
        "EXPENSE_CATEGORY": "For expenses tagged to a project."
      },
      "pick": {
        "PRODUCT_CATEGORY": "Choose a product category",
        "ACCOUNT": "Choose an account",
        "EXPENSE_CATEGORY": "Choose an expense category"
      },
      "none": "Nothing mapped.",
      "search": "Search…",
      "noSource": "Nothing left to map.",
      "category": "Cost category",
      "categoryFor": "Cost category for {{name}}",
      "remove": "Remove the mapping of {{name}}",
      "add": "Add",
      "cannotRead": "You can’t read this list, so it can’t be mapped here.",
      "discard": "Discard changes",
      "save": "Save mapping",
      "saved": "Mapping saved"
    },
    "classLine": "Class: {{class}}"
  }
}
